/**
 * Adzuki.Sort
 */

(function Sort($, Adzuki)
{
	"use strict";

	var sort = {};

	/**
	 * Sort an object by it's values, in alphabetical order.
	 * @param  {object} data [your data]
	 * @return {array}       [array of objects]
	 */
	sort.alphabeticValue = function sortByAlphabeticValue(data)
	{
		var keys   = [],
		    values = [],
		    retArr = [],
		    _key;

		try
		{
			if (typeof data !== 'object') {
				throw new Error('data - expecting object, got ' + typeof data);
			}

			// split keys and values, keeping the order
			for (_key in data)
			{
				if (Object.prototype.hasOwnProperty.call(data, _key))
				{
					if (typeof data[_key] !== 'string') {
						throw new Error('data[_key] - expecting string, got ' + typeof data[_key]);
					}

					keys.push(_key);
					values.push(data[_key]);
				}
			}

			// sort values
			values.sort(function nativeAlphabeticSort(a, b)
			{
				// eslint-disable-next-line no-magic-numbers
				return (a.toLowerCase() < b.toLowerCase()) ? -1 : 1;
			});

			// find keys for values
			values.forEach(function findKeysForSortedValues(value)
			{
				var found = false;

				keys.forEach(function _findKeysSomethingRenameThis(key)
				{
					if (value === data[key] && !found)
					{
						retArr.push({
							key  : key,
							value: data[key],
						});

						found = true;
						return;
					}
				});
			});
		}
		catch (err)
		{
			console.log('[Adzuki.Sort]', err);
		}

		return retArr;
	};

	Adzuki.Sort = sort;
}(jQuery, window.Adzuki || {}));